import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'
import { getTemplate } from '../../NewsboardPostForm.api'
import {
  NEWSBOARD_CREATION_FIELD_NAME_TEXT_TEMPLATE,
  NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE,
  NEWSBOARD_POST_FORM_FIELD_NAME_MESSAGE,
  NEWSBOARD_POST_FORM_FIELD_NAME_TITLE,
} from '../../NewsboardPostForm.constants'
import {
  isTemplateConfirmationInsertReplaceOptionValueInsert,
  TemplateConfirmationModal,
} from '../../TemplateConfirmationModal'

export function useSelectTextTemplate({
  addFiles,
  editorRef,
  setModal,
  onCloseModal,
}) {
  const { setFieldValue, values } = useFormikContext()

  const templateId = values[NEWSBOARD_CREATION_FIELD_NAME_TEXT_TEMPLATE]?.value

  function handleCloseModal() {
    onCloseModal()
  }

  function insertMessageText() {
    getTemplate(templateId).then(({ data }) => {
      setFieldValue(
        NEWSBOARD_POST_FORM_FIELD_NAME_TITLE,
        values[NEWSBOARD_POST_FORM_FIELD_NAME_TITLE] + data.post_title
      )

      if (data.text) {
        editorRef.current.insertContent(data.text)
      }

      addFiles(data.files)
    })
  }

  function replaceMessageText() {
    getTemplate(templateId).then(({ data }) => {
      setFieldValue(NEWSBOARD_POST_FORM_FIELD_NAME_TITLE, data.post_title)

      if (data.text) {
        setFieldValue(NEWSBOARD_POST_FORM_FIELD_NAME_MESSAGE, data.text)
      }

      addFiles(data.files)
    })
  }

  function handleSubmitModal(value) {
    if (
      isTemplateConfirmationInsertReplaceOptionValueInsert(
        value[NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE]
      )
    ) {
      insertMessageText()
    } else {
      replaceMessageText()
    }

    handleCloseModal()
  }

  function setTemplateConfirmationModal() {
    setModal(
      <TemplateConfirmationModal
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
      />
    )
  }

  const textTemplate = values[NEWSBOARD_CREATION_FIELD_NAME_TEXT_TEMPLATE]

  useEffect(() => {
    if (textTemplate) {
      setFieldValue(
        NEWSBOARD_CREATION_FIELD_NAME_TEXT_TEMPLATE,
        FORMIK_EMPTY_VALUE
      )

      if (values[NEWSBOARD_POST_FORM_FIELD_NAME_MESSAGE]) {
        setTemplateConfirmationModal()
      } else {
        insertMessageText()
      }
    }
  }, [textTemplate])
}
